import React, { useMemo } from 'react';
import { geoAlbersUsa, geoPath } from 'd3-geo';
import { feature } from 'topojson-client';
import statesTopo from 'us-atlas/states-10m.json';

const W = 975;
const H = 610;
const projection = geoAlbersUsa().scale(1300).translate([W / 2, H / 2]);
const path = geoPath(projection);

export const KIND_COLORS = { dib: '#F7941D', partner: '#0A0A0A' };

const USMap = ({ locations, activeId, onSelect, activeStates = [] }) => {
    const states = useMemo(() => feature(statesTopo, statesTopo.objects.states).features, []);
    const k = typeof window !== 'undefined' && window.innerWidth < 640 ? 2.2 : 1;
    const pins = locations
        .map((l) => ({ ...l, xy: l.lat != null && l.lng != null ? projection([l.lng, l.lat]) : null }))
        .filter((l) => l.xy);

    return (
        <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto" role="img" aria-label="Map of Dry Ice Bulls and partner locations" data-testid="us-map">
            <g>
                {states.map((s) => (
                    <path key={s.id} d={path(s)}
                        className="transition-[fill] duration-300"
                        fill={activeStates.includes(s.properties.name) ? '#FDE7CC' : '#EDEDED'}
                        stroke="#FFFFFF" strokeWidth={1} />
                ))}
            </g>
            {pins.map((p) => {
                const active = p.id === activeId;
                return (
                    <g key={p.id} transform={`translate(${p.xy[0]},${p.xy[1]})`} className="cursor-pointer"
                        onClick={() => onSelect(p.id)} data-testid={`map-pin-${p.id}`}>
                        <circle r={26 * k} fill="transparent" />
                        {active && <circle r={22 * k} fill={KIND_COLORS[p.kind]} opacity={0.18} className="animate-ping" style={{ transformBox: 'fill-box', transformOrigin: 'center' }} />}
                        <circle r={(active ? 12 : 9) * k} fill={KIND_COLORS[p.kind]} stroke="#fff" strokeWidth={3 * k}
                            className="transition-[r] duration-200" />
                        <title>{`${p.name} — ${p.city}, ${p.state}`}</title>
                    </g>
                );
            })}
        </svg>
    );
};

export default USMap;
